module.exports = __webpack_public_path__ + "static/media/icon-vest-sport.1e3d0354.svg";